import Icon from 'veui/components/Icon'
import { IconRotateClockwise } from 'dls-icons-vue'

Icon.register('rotate-clockwise', IconRotateClockwise)
